// extracted by mini-css-extract-plugin
export default {"container":"ResultCard_container__KF6JG","header":"ResultCard_header__YC92L"};